// Maximums
export const MAX_LATITUDE = 90;
export const MAX_LONGITUDE = 180;
export const MAX_SPIN = 180;
export const MAX_SQUEEZE = 100;
export const MAX_TRIM = 100;
export const MAX_MERIDIAN = 180;  // Added max for meridian
export const MAX_BEELANDING = 90;  // Maximum Bee Landing size in degrees
export const MAX_SURPLUSY = 90;      // Assuming surplusY has an upper bound of 90
export const MAX_SURPLUSX = 90;   // Assuming SurplusX has an upper bound of 90

// Minimums
export const MIN_LATITUDE = -90;  // Latitude ranges from -90 to 90
export const MIN_LONGITUDE = -180;  // Longitude ranges from -180 to 180
export const MIN_SPIN = -180;     // Spin can range from -180 to 180
export const MIN_SQUEEZE = -100;  // Allowing negative pinch values
export const MIN_TRIM = -100;     // Allowing negative trim values
export const MIN_MERIDIAN = -180; // Meridian ranges from -180 to 180
export const MIN_BEELANDING = 0;   // Minimum Bee Landing size in degrees
export const MIN_SURPLUSY = 0;        // SurplusY starts from 0
export const MIN_SURPLUSX = 0;     // SurplusX starts from 0


export const PROJECTION_TYPES = {
  EQUIRECTANGULAR: 'equirectangular',
  PILLOW: 'pillow',
  FLOWER: 'flower',
  CUBE: 'cube',
  DOMES: 'domes',
  TENNIS: 'tennis',
  BASEBALL: 'baseball',
  BASKETBALL: 'basketball'
  /* Temporarily commented out projections
  LAMBERT: 'lambert',
  MERCATOR: 'mercator',
  SOCCER: 'soccer'
  */
} as const;

export const FILE_FORMATS = {
  GLB: 'glb',
  GLTF: 'gltf',
  WEBM: 'webm',
  JPEG: 'jpeg',
  PNG: 'png',
  WEBP: 'webp'
} as const;

// Default values for projections
export const DEFAULT_PETALS = 4; // Default number of petals (or gores)
export const DEFAULT_SURPLUSY = 90; // Default surplusY in degrees
export const DEFAULT_SURPLUSX = 2; // Set this to an appropriate default in degrees (0-90)
export const DEFAULT_MERIDIAN = 0; // Default central meridian adjustment in degrees (-180 to 180)
export const DEFAULT_START_SURPLUSX = -90;
export const DEFAULT_END_SURPLUSX = 90;
export const DEFAULT_BEELANDING = 0; // Default Bee Landing size in degrees
export const DEFAULT_START_SURPLUSY = -90;
export const DEFAULT_END_SURPLUSY = 90;
 